<script setup lang="ts">
import type { RTEBlock } from 'types/blocks';
import type { ComponentStyles } from 'types/index';

defineProps<{
  data: RTEBlock;
  componentStyles?: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper
    v-if="data"
    :component-styles="componentStyles"
  >
    <div class="narrow-container container">
      <BaseRte :content="data.richText" />
    </div>
  </BaseComponentWrapper>
</template>
